import { environment } from '@/environments';

const EnvironmentPlugin = {
  install(Vue) {
    Vue.prototype.$env = environment;
    Vue.environment = environment;
  },
};

export default EnvironmentPlugin;
